import React, {useEffect, useState} from "react";
import PropTypes from "prop-types";

import {getIso31662dbCountries} from "../../../../../../dynamic-packages";
import useForceUpdate from "../../../../../../hooks/useForceUpdate";
import {_t} from "../../../../../../utils/I18nUtils";
import "./BillingInfoForm.style.scss";

let listOfCountries = ['US', 'CA', 'MX'];
const trKey = "components.addFundsForm.billing";
const paymentMethods = ["Visa", "MasterCard", "Amex"];

const BillingInfoForm = (props) => {

    const vm = props.vm;
    const ccInfo = vm.ccInfo;
    const setCcInfo = vm.setCcInfo;
    const [isoDb, setIsoDb] = useState({});
    const forceUpdate = useForceUpdate();

    const validate = () => {
        let errors = {}
        if(vm.billingAddress.address1 == "")
            errors.address1 = "Billing Address: Postal Code is required";
        if(vm.billingAddress.zipCode == "")
            errors.zipCode = "Billing Address: Postal Code is required";
        if(vm.billingAddress.city == "")
            errors.city = "Billing Address: City is required";
        if(vm.billingAddress.country == "" || vm.billingAddress.countryCode == "")
            errors.country = "Billing Address: Country is required";
        if(vm.billingAddress.state == "" || vm.billingAddress.stateCode == "")
            errors.state = "Billing Address: State/Province is required";
        if(ccInfo.fname == "")
            errors.fname = "First Name is required";
        if(ccInfo.lname == "")
            errors.lname = "Last Name is required";

        return {
            isValid: Object.entries(errors).length === 0,
            errors
        }
    }
    const {isValid, errors} = validate();

    useEffect(() => {
        getIso31662dbCountries().then( iso31662db =>{
            iso31662db.countries = iso31662db.countries.filter(c=>listOfCountries.includes(c.iso) )
            setIsoDb(iso31662db);
            forceUpdate();
        });
    }, []);
    useEffect(()=>{
        if(!isValid){
            setCcInfo(ccInfo.set('isCustom', true));
            vm.setSaveAsHomeAddress(true);
        }
    },[isoDb]);

    const handleFirstNameChange = (e) => {
        const firstName = e.target.value;
        setCcInfo(ccInfo.set('fname', firstName));
    };
    const handleLastNameChange = (e) => {
        const lastName = e.target.value;
        setCcInfo(ccInfo.set('lname', lastName));
    };

    return (
        <div className="BillingInfoForm">

            <form>
                <div className="row">
                    <div className="col-6">
                        <div className="form-group">
                            <label>{_t(`${trKey}.paymentTypeLabel`)}</label>
                            <select
                                value={ccInfo.ptype}
                                onChange={(e) => {
                                    setCcInfo(ccInfo.set('ptype', e.target.value));
                                }}
                            >
                                {paymentMethods.map((method) => (
                                    <option key={method} value={method}>
                                        {method}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div className="form-group">
                            <label>{_t(`${trKey}.cardNumberLabel`)}</label>
                            <div className="cardNumber"></div>
                        </div>
                    </div>
                    <div className="col-6">
                        <div className="form-group">
                            <label>{_t(`${trKey}.expirationDateLabel`)}</label>
                            <div className="expiryDate"></div>
                        </div>
                        <div className="form-group">
                            <label>{_t(`${trKey}.securityCodeLabel`)}</label>
                            <div className="cvv"></div>
                        </div>
                    </div>
                </div>
            </form>

            <h3>{_t(`${trKey}.billingInfoTitle`)}</h3>
            <form>
                <div className="row">
                    <div className="col-6">
                        <div className="form-group">
                            <label>{_t(`${trKey}.firstNameLabel`)}</label>
                            <input type="text" style={{width: '100%'}}
                                   onChange={handleFirstNameChange}
                                   value={ccInfo.fname}/>
                            {errors.fname && <div className="error">*</div>}
                        </div>
                    </div>
                    <div className="col-6">
                        <div className="form-group">
                            <label>{_t(`${trKey}.lastNameLabel`)}</label>
                            <input type="text" style={{width: '100%'}}
                                   onChange={handleLastNameChange}
                                   value={ccInfo.lname}/>
                            {errors.lname && <div className="error">*</div>}
                        </div>
                    </div>
                </div>
              <div className="row">
                    <div className="col-12">
                        <div className="checkbox">
                            <input type="checkbox"
                                   id={"isCustom"}
                                   checked={!ccInfo.isCustom}
                                   onChange={(e) => {
                                       setCcInfo(ccInfo.set('isCustom', !ccInfo.isCustom));
                                   }}/>
                            <label htmlFor="isCustom">{_t(`${trKey}.sameAsHomeAddressLabel`)}</label>
                        </div>
                    </div>
                </div>
                {!ccInfo.isCustom &&
                    <div className="row">
                        <div className="col-12">
                            <div className="address">
                                {vm.billingAddress.address1 != "" ? <div>{vm.billingAddress.address1}</div> : null}
                                {vm.billingAddress.address2 != "" ? <div>{vm.billingAddress.address2}</div> : null}
                                <div>
                                    {vm.billingAddress.city != "" ? <span>{vm.billingAddress.city}&nbsp;</span> : null}
                                    {vm.billingAddress.state != "" ? <span>{vm.billingAddress.state}&nbsp;</span> : null}
                                    {vm.billingAddress.zipCode != "" ? <span>{vm.billingAddress.zipCode}</span> : null}</div>
                                <div>
                                {vm.billingAddress.country != "" ? <span>{vm.billingAddress.country}</span> : null}</div>
                            </div>
                        </div>
                    </div>}
                {ccInfo.isCustom && <React.Fragment>
                    <div className="customBillingAddress">
                        <div className="row">
                            <div className="col-12">
                                <div className="form-group">
                                    <label>{_t(`${trKey}.countryLabel`)}</label>
                                    <select
                                        value={
                                            isoDb?.countries?.find(
                                                (x) =>
                                                    x.name.toLowerCase() === vm.billingAddress.country.toLowerCase() ||
                                                    x.iso === vm.billingAddress.countryCode
                                            )?.iso || ""
                                        }
                                        onChange={(e) => {
                                            const selectedCountry = isoDb?.countries?.find((x) => x.iso === e.target.value);
                                            vm.setBillingAddress(
                                                {
                                                   ...vm.billingAddress,
                                                   "countryCode": selectedCountry?.iso,
                                                   "country": selectedCountry?.name,
                                                   "state": isoDb?.countries[selectedCountry?.iso]?.regions?.[0]?.name ?? "",
                                                   "stateCode": isoDb?.countries[selectedCountry?.iso]?.regions?.[0]?.iso || ""
                                                });
                                        }}
                                    >
                                        {isoDb?.countries?.map((country) => (
                                            <option key={country.iso}
                                                    value={country.iso}>
                                                {country.name}
                                            </option>
                                        ))}
                                    </select>
                                    {errors.country && <div className="error">*</div>}
                                </div>
                            </div>
                            {(isoDb?.listOfCountries?.[vm.billingAddress.countryCode]?.regions?.length > 0) &&
                                <div className="col-6">
                                    <div className="form-group">
                                        <label>{_t(`${trKey}.stateLabel`)}</label>
                                        <select
                                            value={
                                                isoDb?.listOfCountries?.[vm.billingAddress.countryCode]?.regions.find(
                                                    (x) =>
                                                        x.name.toLowerCase() === vm.billingAddress.state.toLowerCase() ||
                                                        x.iso === vm.billingAddress.stateCode
                                                )?.iso || ""
                                            }
                                            onChange={(e) => {
                                                const selectedRegion = isoDb?.listOfCountries?.[vm.billingAddress.countryCode]?.regions?.find(
                                                    (x) => x.iso === e.target.value
                                                );
                                                vm.setBillingAddress({
                                                    ...vm.billingAddress,
                                                    "state": selectedRegion?.name || "",
                                                    "stateCode": selectedRegion?.iso || ""
                                                });
                                            }}
                                        >
                                            {isoDb?.listOfCountries?.[vm.billingAddress.countryCode]?.regions?.map((region) => (
                                                <option key={region.iso} value={region.iso}>
                                                    {region.name}
                                                </option>
                                            ))}
                                        </select>
                                        {errors.state && <div className="error">*</div>}
                                    </div>
                                </div>}
                        </div>
                        <div className="row">
                            <div className="col-6">
                                <div className="form-group">
                                    <label>{_t(`${trKey}.addressLabel`)}</label>
                                    <input type="text" style={{width: '100%'}}
                                           onChange={(e) => {
                                               vm.setBillingAddress({...vm.billingAddress,
                                                                     address1: e.target.value});
                                           }}
                                           name="Address"
                                           value={vm.billingAddress.address1}/>
                                    {errors.address1 && <div className="error">*</div>}
                                </div>
                            </div>
                            <div className="col-6">
                                <div className="form-group">
                                    <label>{_t(`${trKey}.cityLabel`)}</label>
                                    <input type="text" style={{width: '100%'}}
                                           onChange={(e) => {
                                               vm.setBillingAddress({...vm.billingAddress, city: e.target.value});
                                           }}
                                           value={vm.billingAddress.city}/>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                        <div className="col-6">
                                <div className="form-group">
                                    <label>{_t(`${trKey}.zipCodeLabel`)}</label>
                                    <input type="text" style={{width: '100%'}}
                                           onChange={(e) => {
                                               vm.setBillingAddress({...vm.billingAddress, zipCode: e.target.value});
                                           }}
                                           value={vm.billingAddress.zipCode}/>
                                </div>
                            </div>
                            <div className="col-6">
                                <div className="form-group">
                                    <label>{_t(`${trKey}.phoneLabel`)}</label>
                                    <input type="text" style={{width: '100%'}}
                                           onChange={(e) => {
                                               vm.setBillingAddress({...vm.billingAddress, phone1: e.target.value});
                                           }}
                                           value={vm.billingAddress.phone1}/>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <div className="checkbox">
                                    <input type="checkbox"
                                           id={"saveAsHomeAddress"}
                                           checked={vm.saveAsHomeAddress}
                                           onChange={e => {
                                               vm.setSaveAsHomeAddress(!vm.saveAsHomeAddress);
                                           }}
                                    />
                                    <label
                                        htmlFor="saveAsHomeAddress">{_t(`${trKey}.saveAsHomeAddressLabel`)}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <br/><br/>
                </React.Fragment>}
            </form>

        </div>
    );
}

BillingInfoForm.propTypes = {
    onFormValidChange: PropTypes.func,
};

export default BillingInfoForm;